// extracted by mini-css-extract-plugin
export default {"timerPopup":"TimerPopup_timerPopup__s3ufN","timerContent":"TimerPopup_timerContent__AB+cJ"};